/**
 * URLs de `/widget/*` (p. ej. conversation-media firmado): deben resolverse contra el
 * mismo origen que la SPA para que el proxy de Vite o el reverse proxy reenvíen al API.
 * Si se antepone `VITE_PUBLIC_AGENT_API_URL` con localhost, en móvil u otra máquina las
 * imágenes apuntan al localhost del dispositivo y quedan rotas.
 */
export function resolveWidgetMediaUrl(pathOrUrl: string): string {
  if (pathOrUrl.startsWith('data:')) return pathOrUrl;

  if (typeof window !== 'undefined') {
    if (pathOrUrl.startsWith('/widget')) {
      const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
      return `${window.location.origin}${path}`;
    }
    if (/^https?:\/\//i.test(pathOrUrl)) {
      try {
        const u = new URL(pathOrUrl);
        const loopback = u.hostname === 'localhost' || u.hostname === '127.0.0.1';
        if (loopback && u.pathname.startsWith('/widget')) {
          return `${window.location.origin}${u.pathname}${u.search}${u.hash}`;
        }
      } catch {
        /* ignore */
      }
      return pathOrUrl;
    }
  }

  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) return pathOrUrl;
  const envBase = import.meta.env.VITE_PUBLIC_AGENT_API_URL?.replace(/\/$/, '') ?? '';
  if (envBase) return `${envBase}${pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`}`;
  if (import.meta.env.DEV && pathOrUrl.startsWith('/widget')) return pathOrUrl;
  return pathOrUrl;
}
